export default {
  props: ['ticketData'],
  methods: {
    baseUrl() {
      return process.env.VUE_APP_BASE_IMAGE_URL
    },
  },
}
